import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Link } from '@/components/ui/link'
import { Text } from '@/components/ui/typography'
import { widgetsAtom } from '@/store/tasksApprovals/widgets'

const AdditionalInfo = ({ parentURL, systemID }: { parentURL: string; systemID: string }) => {
    const [widgets] = useAtom(widgetsAtom)
    const systemName = widgets.filter((i) => i.id === systemID)[0]?.system_name
    const { t } = useTranslation()
    return (
        <Box px="24px">
            <Text fontSize="12px" pb="4px">
                {t('tasksApprovals.approvals.additional_information')}
            </Text>
            <Link href={parentURL} isExternal textDecor="underline" fontSize="14px" fontWeight="bold">
                {t('tasksApprovals.approvals.view_request', { name: systemName, interpolation: { escapeValue: false } })}
            </Link>
        </Box>
    )
}

export default AdditionalInfo
